import React from "react";
import BuildingImage from "../../../../assets/images/whoWeAre.png";
import { cardsData } from "./config";
import {
  Container,
  MainContainer,
  LeftContainer,
  ImageContainer,
  RightContainer,
  CardsContainer,
  Card,
  HeadingContainer,
  Title,
  SubTitle,
  CardHeading,
  CardDescription,
} from "./styled.components";

const WhoWeAre = () => {
  return (
    <Container>
      <MainContainer>
        <LeftContainer>
          <ImageContainer loading="lazy" src={BuildingImage} />
        </LeftContainer>
        <RightContainer>
          <HeadingContainer>
            <Title>Who We Are</Title>
            <SubTitle>
              HHH and Sons Presents a Proud Past And Will Keep The Promise For
              Days To Come
            </SubTitle>
          </HeadingContainer>
          <CardsContainer>
            {cardsData.map((_item) => {
              return (
                <Card>
                  <CardHeading>{_item.heading}</CardHeading>
                  <CardDescription>{_item.description}</CardDescription>
                </Card>
              );
            })}
          </CardsContainer>
        </RightContainer>
      </MainContainer>
    </Container>
  );
};

export default WhoWeAre;
